(() => {
  if (window.AuziInstallmentSync) return;
  // The only visible financing copy is Shopify's own native payment_terms widget.
  // Keep the native Shopify terms visible, including when the customer has an active offer.
  let pending = false;
  const refresh = () => {
    pending = false;
    const offer = window.AuziOffer?.get?.() || null;
    document.querySelectorAll('.auzi-product-payment-terms').forEach(wrapper => {
      wrapper.querySelectorAll('[data-auzi-discount-terms]').forEach(node => node.remove());
      const section = wrapper.closest('product-info');
      const variantID = section?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const price = section?.querySelector('[data-auzi-price-root]');
      const native = wrapper.querySelector('shopify-payment-terms');
      if (native && variantID && native.getAttribute('variant-id') !== String(variantID)) {
        native.setAttribute('variant-id', String(variantID));
      }
      const handle = price?.dataset.auziProductHandle || '';
      const targeted = Boolean(offer && (
        offer.scope === 'all' || offer.scope === 'unknown' || !offer.scope ||
        (offer.scope === 'products' && Array.isArray(offer.products) && offer.products.includes(handle))
      ));
      // Clear any inline hiding by the old custom-terms implementation.
      native?.style.removeProperty('display');
      wrapper.style.removeProperty('display');
    });
  };
  const queue = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(refresh);
  };
  window.addEventListener('auzi:offer:activated',queue);
  window.addEventListener('auzi:offer:cleared',queue);
  window.addEventListener('auzi:variant-price-changed',queue);
  document.addEventListener('shopify:section:load',queue);
  document.addEventListener('change',e=>{if(e.target.matches?.('form[action*="/cart/add"] input[name="id"]'))queue()});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',queue,{once:true});
  else queue();
  window.AuziInstallmentSync = { update: queue };
})();